import { call, put, takeLatest } from 'redux-saga/effects'

import { addNote, showNote, editNote, getAllNotes, deleteNote } from './note.reducer'
import Api from '../services/ApiCaller'
import { showErrorMessage, showMessage } from '../utils'
import { translate } from '../i18n'

export function* getAllNotesRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getAllNotes.success(res))
    } else {
      showErrorMessage(message)
      yield put(getAllNotes.failure(message))
    }
  } catch (e) {
    yield put(getAllNotes.failure(e.message))
  }
}
function* getNoteByIdRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error } = res
    if (!error) {
      yield put(showNote.success(res))
    }
  } catch (e) {
    yield put(showNote.failure())
  }
}
export function* addNoteRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(`${translate('note.messages.successfulAdd')}`)
      yield put(addNote.success(res))
    } else {
      yield put(addNote.failure(message))
    }
  } catch (e) {
    yield put(addNote.failure(e.message))
  }
}
function* editNoteRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error } = res
    if (!error) {
      yield put(editNote.success(res))
      showMessage(`${translate('note.messages.successfulEdit')}`)
    }
  } catch (e) {
    yield put(editNote.failure())
  }
}
export function* deleteNoteRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(`${translate('note.messages.successfulDelete')}`)
      yield put(deleteNote.success({id: payload.id}))
    } else {
      yield put(deleteNote.failure(message))
    }
  } catch (e) {
    yield put(deleteNote.failure(e.message))
  }
}
interface IidData {
  id: number
}

interface InoteContent {
  id: number
  content: {}
}

interface IdeleteNote {
  id: number
  patientId: number
}

export default (api: any) => {
  const getAllNotesApi = (data: IidData) => api.get(`/notes/${data.id}`, data)
  const getNoteByIdApi = (data: any) => api.get(`/notes/${data.patientId}/${data.noteId}`)
  const editNoteApi = (data: any) => api.put(`/notes/${data.patientId}/${data.noteId}`, data.payload)
  const addNoteApi = (data: InoteContent) => api.post(`/notes/${data.id}`, data.content)
  const deleteNoteApi = (data: IdeleteNote) => api.delete(`/notes/${data.patientId}/${data.id}`)
  return [
    takeLatest(getAllNotes.TRIGGER, getAllNotesRequest, getAllNotesApi),
    takeLatest(addNote.TRIGGER, addNoteRequest, addNoteApi),
    takeLatest(editNote.TRIGGER, editNoteRequest, editNoteApi),
    takeLatest(showNote.TRIGGER, getNoteByIdRequest, getNoteByIdApi),
    takeLatest(deleteNote.TRIGGER, deleteNoteRequest, deleteNoteApi),
  ]
}
